/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateGcpKmsKeyForm,
  CreateGcpKmsKeyForm$Outbound,
  CreateGcpKmsKeyForm$outboundSchema,
} from "../components/creategcpkmskeyform.js";

export type CreateGcpKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateGcpKmsKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createGcpKmsKeyForm: CreateGcpKmsKeyForm;
};

/** @internal */
export type CreateGcpKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateGcpKmsKeySecurity$outboundSchema: z.ZodMiniType<
  CreateGcpKmsKeySecurity$Outbound,
  CreateGcpKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createGcpKmsKeySecurityToJSON(
  createGcpKmsKeySecurity: CreateGcpKmsKeySecurity,
): string {
  return JSON.stringify(
    CreateGcpKmsKeySecurity$outboundSchema.parse(createGcpKmsKeySecurity),
  );
}

/** @internal */
export type CreateGcpKmsKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateGcpKmsKeyForm: CreateGcpKmsKeyForm$Outbound;
};

/** @internal */
export const CreateGcpKmsKeyRequest$outboundSchema: z.ZodMiniType<
  CreateGcpKmsKeyRequest$Outbound,
  CreateGcpKmsKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createGcpKmsKeyForm: CreateGcpKmsKeyForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createGcpKmsKeyForm: "CreateGcpKmsKeyForm",
    });
  }),
);

export function createGcpKmsKeyRequestToJSON(
  createGcpKmsKeyRequest: CreateGcpKmsKeyRequest,
): string {
  return JSON.stringify(
    CreateGcpKmsKeyRequest$outboundSchema.parse(createGcpKmsKeyRequest),
  );
}
